import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useOrgDashboardQuery } from '../../queries/orgDashboard_gen'
import {
  UpdateOnboardingStepMutationVariables,
  useUpdateOnboardingStepMutation,
} from './updateOnboardingStep_gen'

type UseStartOnboardingStepOptions = UseGqlMutationCallbacks<
  void,
  Pick<UpdateOnboardingStepMutationVariables['input'], 'stepType'>
>

export const useStartOnboardingStep = (orgId: number, mutationOptions?: UseStartOnboardingStepOptions) => {
  const { data: orgData } = useOrgDashboardQuery({ orgId })
  const org = orgData?.organization
  const { mutateAsync: updateOnboardingStep } = useUpdateOnboardingStepMutation()

  return useMutationWithInvalidation(
    ({ stepType }) => {
      if (!org?.onboardingWorkflow || org.isOnboarded) return Promise.resolve() // no step to update - that's fine
      updateOnboardingStep({ input: { stepType, orgId: org.id, isStarted: true } })
      return Promise.resolve()
    },
    mutationOptions,
    [useOrgDashboardQuery.getKey({ orgId: org?.id })] // Only invalidate the specific organization query
  )
}
